import { render, staticRenderFns } from "./SectionProductsCreate.vue?vue&type=template&id=cd7ce778&scoped=true&"
import script from "./SectionProductsCreate.vue?vue&type=script&lang=js&"
export * from "./SectionProductsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7ce778",
  null
  
)

export default component.exports